module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-forgot-password-request clearfix"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.labels['50']))]), _vm._v(" "), _c('label', {
    staticClass: "box-input-material position-up clearfix"
  }, [_c('div', {
    staticClass: "fa fa-id-card icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forgotIdCardNo),
      expression: "forgotIdCardNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "upper",
    class: {
      'focus': _vm.forgotIdCardNo != '', 'input-error': _vm.errors.has('idCardNo')
    },
    attrs: {
      "name": "idCardNo"
    },
    domProps: {
      "value": (_vm.forgotIdCardNo)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.$refs.usernameInput.focus()
      }, function($event) {
        _vm.clearResponse()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forgotIdCardNo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels['140']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('idCardNo')),
      expression: "errors.has('idCardNo')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('idCardNo')))])]), _vm._v(" "), _c('label', {
    staticClass: "box-input-material position-up clearfix"
  }, [_c('div', {
    staticClass: "glyphicon glyphicon-user icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forgotUsername),
      expression: "forgotUsername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "usernameInput",
    staticClass: "upper",
    class: {
      'focus': _vm.forgotUsername != '', 'input-error': _vm.errors.has('username')
    },
    attrs: {
      "name": "username"
    },
    domProps: {
      "value": (_vm.forgotUsername)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.$refs.emailInput.focus()
      }, function($event) {
        _vm.clearResponse()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forgotUsername = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels['20']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])]), _vm._v(" "), _c('label', {
    staticClass: "box-input-material clearfix"
  }, [_c('div', {
    staticClass: "fa fa-envelope icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forgotEmail),
      expression: "forgotEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    ref: "emailInput",
    class: {
      'focus': _vm.forgotEmail != '', 'input-error': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.forgotEmail)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.validateInput()
      }, function($event) {
        _vm.clearResponse()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forgotEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels['70']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), (_vm.loadingDisp) ? _c('div', {
    staticClass: "infinite-loading-container"
  }, [_c('i', {
    staticClass: "loading-wave-dots"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.response !== ''),
      expression: "response !== ''"
    }],
    staticClass: "response-msg",
    class: _vm.getStatusResponse
  }, [_vm._v(_vm._s(_vm.response))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispBtnOk),
      expression: "!dispBtnOk"
    }],
    staticClass: "btn-forgot submit",
    on: {
      "click": function($event) {
        _vm.validateInput()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['120']))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispBtnOk),
      expression: "!dispBtnOk"
    }],
    staticClass: "btn-forgot cancel",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['110']))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1081678!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/forgotPasswordRequest.vue
// module id = 3943
// module chunks = 1